import * as React from 'react';
import { useForecastStore } from 'src/hooks/forecast';
import useReduxState from 'src/hooks/useReduxState';
import { useState, useEffect } from 'react';
import System from 'src/helper/system';

const ForecastCount = (props) => {
    const [{ forecast_counts }, { }] = useForecastStore();
    const [forecastSearchCpnStatus, setForecastSearchCpnStatus] = useReduxState('', 'setForecastSearchCpnStatus')
    const [selectedCount, setSelectedCount] = useState('')

    useEffect(() => {
        setSelectedCount(forecastSearchCpnStatus && forecastSearchCpnStatus.key)
    }, [forecastSearchCpnStatus])

    return (
        <div className='col-md-8'>
            {
                forecast_counts &&
                <div className='bs5 row g20'>
                    <div className='col-md-4 m-b-30'>
                        <div className={'contstrain-legend ' + (selectedCount === '' ? 'contstrain-legend-selected' : '')}
                            onClick={() => setForecastSearchCpnStatus({ key: '', slug: 'All' })}>
                            <span className='constrain-legend-title'>Total</span>
                            <span className='constrain-legend-desc'>{forecast_counts.total}</span>
                        </div>
                    </div>
                    <div className='col-md-4 m-b-30'>
                        <div className={'contstrain-legend contstrain-legend-nonconstraint ' + (selectedCount === 'G' ? 'contstrain-legend-selected' : '')}
                            onClick={() => setForecastSearchCpnStatus({ key: 'G', slug: 'Non Constraint' })}>
                            <span className='constrain-legend-title'>Non Constraint</span>
                            <span className='constrain-legend-desc'>{forecast_counts.nonConstraint}</span>
                        </div>
                    </div>
                    <div className='col-md-4 m-b-30'>
                        <div className={'contstrain-legend contstrain-legend-constraint ' + (selectedCount === 'R' ? 'contstrain-legend-selected' : '')}
                            onClick={() => setForecastSearchCpnStatus({ key: 'R', slug: 'Constraint' })}>
                            <span className='constrain-legend-title'>Constraint</span>
                            <span className='constrain-legend-desc'>{forecast_counts.constraint}</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default ForecastCount;